export default __webpack_public_path__ + "static/media/Workshop_18A0238.81ba2508.jpg";